import { render } from "./breadcrumb.vue?vue&type=template&id=00643912&scoped=true"
import script from "./breadcrumb.vue?vue&type=script&lang=js"
export * from "./breadcrumb.vue?vue&type=script&lang=js"

import "./breadcrumb.vue?vue&type=style&index=0&id=00643912&scoped=true&lang=less"

import exportComponent from "/home/runner/work/easticloud-admin/easticloud-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00643912"]])

export default __exports__